import { FloatingFormItem } from '@/components/_common';
import EmployeesByCompanySelectField from '@/components/_common/EmployeesByCompanySelectField';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Row, Select } from 'antd';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkorderForms } from '../../WorkOrderFormProvider';
import CommissionsItensList from '../CommissionsItensList';

const typeOptions = [
  { value: WorkOrderItemType.Undefined, label: 'Peças e Serviços' },
  { value: WorkOrderItemType.Part, label: 'Peça' },
  { value: WorkOrderItemType.Service, label: 'Serviço' },
];

export interface CommissionFormFilter {
  employeeId?: number;
  complementId?: number;
  itemType: WorkOrderItemType;
}

const CommissionsItens: React.FC = () => {
  const {
    workorder: { data: workorder },
  } = useWorkorderDetailContext();

  const ruleDefault = useDefaultEmptyFieldError();

  const history = useHistory();

  const { forms, formsValues } = useWorkorderForms();

  const form = forms.commissions;

  const [formFilter] = Form.useForm<CommissionFormFilter>();
  const filterEmployeeId = Form.useWatch('employeeId', formFilter);

  useEffect(() => {
    if (formsValues.commissions?.employeeId && !filterEmployeeId) {
      formFilter.setFieldValue(
        'employeeId',
        formsValues.commissions.employeeId,
      );
    } else if (!formsValues.commissions?.employeeId && filterEmployeeId) {
      form?.setFieldValue('employeeId', filterEmployeeId);
    }
  }, [formsValues.commissions, filterEmployeeId]);

  useEffect(() => {
    formFilter?.setFieldValue('employeeId', null);
    formFilter?.setFieldValue('itemType', WorkOrderItemType.Part);
    form?.setFieldValue('items', null);
  }, [history.location.key, history.location.hash]);

  return (
    <>
      <Form
        form={formFilter}
        onValuesChange={async (fieldValues) => {
          if (fieldValues.employeeId || fieldValues.itemType) {
            form?.setFieldValue('items', []);
            await form?.validateFields(['employeeId']);
          }
        }}
        style={{ marginBottom: 24 }}
      >
        <Row gutter={[24, 24]}>
          <Col span={24} md={12} lg={6}>
            <FloatingFormItem
              name="employeeId"
              label="Funcionário"
              rules={[ruleDefault]}
              style={{ margin: 0 }}
            >
              <EmployeesByCompanySelectField
                companyId={workorder?.company.id}
                style={{ width: '100%' }}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12} lg={6}>
            <FloatingFormItem
              name="itemType"
              label="Tipo"
              initialValue={WorkOrderItemType.Undefined}
              style={{ margin: 0 }}
            >
              <Select options={typeOptions} style={{ width: '100%' }} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>

      <Form name="commissions" form={form}>
        <Form.Item name="employeeId" hidden>
          <Input />
        </Form.Item>

        <CommissionsItensList
          key={history.location.key}
          formFilter={formFilter}
        />
      </Form>
    </>
  );
};

export default CommissionsItens;
